export const environment = {
  production: true,
  BASE_URL: 'https://zero.aplygo.com/',
  hotjar_code: 903806,
  sas: true,
  company_color: '#037acd',
  imageUrl: 'static/images/',
  environment_language_file: 'dev-aplygo_',
  feedbackClient: 'zero',
  cookiebot_uuid: '8bd9ee58-d4eb-43eb-9dcf-cd38161f9fcd'
};
